import { render } from "./OnboardingSuccess.vue?vue&type=template&id=59d261d2"
import script from "./OnboardingSuccess.vue?vue&type=script&lang=js"
export * from "./OnboardingSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__